(function (WGo) {

	WGo.Board.drawHandlers['SQF'] = {
		stone: {
			draw: function (args, board) {
				var xr = board.getX(args.x),
					yr = board.getY(args.y),
					sr = Math.round(board.stoneRadius),
					ratio = args.ratio;
				sr = sr * ratio;
				this.lineWidth = args.lineWidth || theme_variable("markupLinesWidth", board) || 1;
				this.beginPath();
				this.fillStyle = args.c || get_markup_color(board, args.x, args.y);
				this.rect(Math.round(xr - sr / 2) - board.ls, Math.round(yr - sr / 2) - board.ls, sr, sr);
				this.fill();
			}
		}
	}
	var theme_variable = function (key, board) {
		return typeof board.theme[key] == "function" ? board.theme[key](board) : board.theme[key];
	}
	var ScoreMode = function (player, callback) {
		this.originalPosition = player.kifuReader.game.position;
		this.player = player;
		this.position = this.originalPosition.clone();
		this.board = player.board;
		this.callback = callback;
	}
	var state = ScoreMode.state = {
		UNKNOWN: 0,
		BLACK_STONE: 1, // must be equal to WGo.B
		WHITE_STONE: -1, // must be equal to WGo.W
		BLACK_CANDIDATE: 2,
		WHITE_CANDIDATE: -2,
		BLACK_NEUTRAL: 3,
		WHITE_NEUTRAL: -3,
		NEUTRAL: 4,
	}
	ScoreMode.prototype.start = function (result) {
		this.player.setFrozen(true);
		// if(waiting) {
		// 	if(window.plus) {
		// 		this.waiting = plus.nativeUI.showWaiting();
		// 	} else {
		// 		this.waiting = waiting;
		// 		this.waiting.show();
		// 	}
		// }
		this.result = result;
		this.saved_state = this.board.getState();
		this.displayScore();
		// setTimeout(function() {
		// 	this.waiting && this.waiting.close();
		// }.bind(this), 200)
		var RU = this.player.kifuReader.kifu.info["RU"] || 'cn';
		RU = RU.toLocaleLowerCase().trim();
		RU = RU != 'jp' ? 'cn' : RU;
		this.callback && this.callback(RU);
	}
	ScoreMode.prototype.end = function () {
		// this.waiting && this.waiting.close();
		this.board.restoreState({
			objects: WGo.clone(this.saved_state.objects)
		});
		this.player.setFrozen(false);
	}
	ScoreMode.prototype.calculateKm = function (km, ha) {
		var colorText = ''
		var result = ''
		var ha = ha
		ha = ha == 1 ? 0 : ha
		result = (ha + km) / 2
		if (result > 0) {
			colorText = '黑'
		} else if (result == 0) {
			colorText = ''
		} else {
			colorText = '白'
		}
		return colorText + '贴' + Math.abs(result) + '子'
	}
	ScoreMode.prototype.displayScore = function () {
		var score = {
			black: [],
			white: [],
		}
		this.newpos = new WGo.Position(this.board.size)
		this.newpos.schema = this.result;
		for (var i = 0; i < this.position.size; i++) {
			for (var j = 0; j < this.position.size; j++) {
				var s = this.newpos.get(i, j)
				var t = this.originalPosition.get(i, j);
				if (s > 0.1 && t != WGo.B) {
					score.black.push({
						x: i,
						y: j,
						type: "SQF",
						c: "black",
						ratio: Math.sqrt(s),
					})
				}
				if (s < -0.1 && t != WGo.W) {
					score.white.push({
						x: i,
						y: j,
						type: "SQF",
						c: "white",
						ratio: Math.sqrt(Math.abs(s)),
					})
				}
			}
		}
		this.board.addObject(score.black);
		this.board.addObject(score.white);
	}

	WGo.ScoreMode = ScoreMode;
})(WGo)
